const TurnoCanceladoIcon = ({ color }) => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="13.5"
        cy="13.5"
        r="12.1829"
        fill="#ECECEC"
        stroke="#CBCBCB"
        strokeWidth="2.63415"
      />
      <path
        d="M7.24219 13.8295L11.1934 18.11L19.7544 9.21973"
        stroke="#CBCBCB"
        strokeWidth="2.63415"
      />
      <circle
        cx="13.5"
        cy="13.5"
        r="12.1829"
        fill="#006299"
        stroke="var(--color-latex10)"
        strokeWidth="2.63415"
      />
      <rect x="6" y="12" width="15" height="3" fill="white" />
    </svg>
  );
};

export default TurnoCanceladoIcon;
